<template>
  <div class="container">
    <h1>
      Images
    </h1>
    <hr>
    <div class="card-columns">

      <div v-if="canAdd" class="card" @click="$router.push({path: `/images/new`})">
        <div class="card-body">
          <h1 class="card-new">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
          </h1>
        </div>
      </div>

      <card v-for="item in items" :item="item" :key="item._id"></card>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Card from "./_Card";

export default {
  name: "image-index",
  components: {
    Card
  },
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin"
    }),
    ...mapState({
      // slots: state => state.images.slots,
      items: state => state.images.all
    }),
    showSlots() {
      return !this.isAdmin; // && this.slots.maximum > 0;
    },
    canAdd() {
      return true; // this.slots.current < this.slots.maximum || this.isAdmin;
    }
  },
  methods: {
    ...mapActions({
      imagesAll: "images/all" // ,
      // imagesSlots: "images/slots"
    }),
    async getData() {
      try {
        // this.imagesSlots();
        this.imagesAll();
        this.$embers.pageData("Images");
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
